import { useEffect } from 'react';

// وظيفة لمعالجة العناصر القابلة للتخصيص مع قيود الاختيار
const useCustomizableItemHandler = (singleItem, size, selectedEdits, setSelectedEdits, setIsValid) => {
  // التحقق مما إذا كان العنصر يستخدم خاصية editsBySize وتحديث الصلاحية
  useEffect(() => {
    // التحقق مما إذا كان العنصر يستخدم خاصية editsBySize
    if (singleItem.editsBySize) {
      let maxSelections = singleItem.editsCount || 0;
      
      // التحقق من صلاحية عدد الاختيارات
      const isValidSelectionCount = selectedEdits.length === maxSelections;
      
      // تحديث حالة الصلاحية
      if (setIsValid) {
        setIsValid(isValidSelectionCount);
      }
    }
  }, [singleItem, selectedEdits, setIsValid]);

  // وظيفة للتحقق من إمكانية إضافة اختيار جديد
  const canAddEdit = () => {
    if (!singleItem.editsBySize) return true;
    
    let maxSelections = singleItem.editsCount || 0;
    
    return selectedEdits.length < maxSelections;
  };

  // إرجاع الوظائف والمتغيرات اللازمة
  return {
    canAddEdit,
    getEditsForCurrentSize: () => {
      return singleItem.edits || [];
    }
  };
};

export default useCustomizableItemHandler; 